"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateAddress = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const DeliveryForm_utils_1 = require("./DeliveryForm.utils");
const addressFields_utils_1 = require("../../form/address-fields/addressFields.utils");
const useValidateAddress = ({ address, country, trigger, shouldValidate = true, isFormActive, }) => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.checkout);
    const [isValidAddress, setIsValidAddress] = (0, react_1.useState)(true);
    const shouldValidateRef = (0, react_1.useRef)(shouldValidate);
    (0, react_1.useEffect)(() => {
        if (!(0, addressFields_utils_1.hasPrefilledAddress)(address)) {
            setIsValidAddress(false);
            shouldValidateRef.current = true;
            return;
        }
        const validateForm = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const isValid = yield (0, DeliveryForm_utils_1.getDeliveryAddressValidationSchema)({ t, country }).isValid(address);
            setIsValidAddress(isValid);
            if (!isValid) {
                yield trigger('customer.address');
                shouldValidateRef.current = false;
            }
        });
        if (address && shouldValidateRef.current) {
            validateForm();
        }
    }, [address, country, shouldValidate, isFormActive]);
    return { isValidAddress };
};
exports.useValidateAddress = useValidateAddress;
